import {ref} from 'vue'
import {defineStore} from 'pinia'

export const useFeedbackModalStore = defineStore('feedbackModal', () => {
  const feedbackModalOpen = ref(false)
  const feedbackHashString = 'feedback_open=&';

  const openFeedbackModal = () => {
    feedbackModalOpen.value = true
  }

  const closeFeedbackModal = () => {
    feedbackModalOpen.value = false
  }

  const addFeedbackHash = () => {
    removeFeedbackHash()
    window.location.hash = window.location.hash + feedbackHashString
  }

  const removeFeedbackHash = () => {
    window.location.hash = window.location.hash.replace(feedbackHashString, '')
  }

  return { feedbackModalOpen, openFeedbackModal, closeFeedbackModal, addFeedbackHash, removeFeedbackHash, feedbackHashString }
})
